module.exports = __webpack_public_path__ + "img/fin_03_发现相框.07240d7e.jpg";